import React from 'react';
import StepperContent from './StepperContent';
import Stepper from 'Stepper/Stepper';


function CaseDetailsStepper({
    currentStep, 
    setContentStep, 
    contentStep, 
    caseDetails, 
    setUpdateComp, 
    requestPopupRef
}) {
  return (
      <div className='w-full bg-cream pt-2 lg:pt-8 font-plexsans' >
            <div className='hidden lg:block w-full text-left pl-10 text-[rgba(20,33,61,.55)] pb-5 text-[13px]'>
                Track your case progress
            </div>
            <Stepper
            currentStep={currentStep} 
            setContentStep={setContentStep} 
            contentStep={contentStep} 
            caseDetails={caseDetails}
            />
            <StepperContent contentStep={contentStep} 
            caseDetails={caseDetails}
            setUpdateComp = {setUpdateComp}
            requestPopupRef={requestPopupRef}
            />
    </div>
  )
}

export default CaseDetailsStepper
